import Vue from 'vue'
import Router from 'vue-router'

import People from "@/components/people"
import Tianboss from "@/components/tianboss"
import Zhengui from "@/components/zhengui"
import Zheno from "@/components/zheno"

// tcpRoules
import Server_rules from "@/tcp/server_rules"
//cooperation(企鹅登录) Register（合作页）
import Cooperation from "@/components/cooperation"
import Register from "@/components/register"
//520活动页
import Login from "@/components/active/login"
import Start from "@/components/active/view/start"
import Home from "@/components/active/view/home"
import Setname from "@/components/active/view/setname"
import Setprice from "@/components/active/view/setprice"
import Otherhome from "@/components/active/view/otherhome"
import Goods from "@/components/active/view/goods"
import Customer from "@/components/active/view/customer"
import Buy from "@/components/active/view/buy"
import Complete from "@/components/active/view/complete"
//注销申请表

// 微信分享
import restoreUrl from "../assets/js/restoreUrl"
import store from '../store/store'
Vue.use(Router)

const router = new Router({
  mode:"history",
  // base:'/activity',
  routes: [
    {
      path: '/people',
      component: People
    },
    {
      path: '/tianboss',
      component: Tianboss
    },
    {
      path: '/zhengui',
      component: Zhengui
    },
    {
      path: '/zheno',
      component: Zheno
    },
    // 月卡续费服务规则
    {
      path: '/server_rules',
      component: Server_rules
    },
    //企鹅公路 type=2
    {
      path: '/team_work',
      component: Cooperation
    },
    //蛋壳活动 type=1
    {
      path: '/register',
      component: Register
    },
    //520活动页
    {
      name:"登录页",
      path:"/login",
      component:Login,
    },
    {
      name:"开启页",
      path:"/start",
      component:Start
    },
    {
      name:"店铺名称",
      path:"/setname",
      component:Setname
    },
    {
      name:"设置商品价格",
      path:"/setprice",
      component:Setprice
    },
    {
      name:"他人店铺首页",
      path:"/otherhome/:id",
      component:Otherhome
    },
    {
      name:"商品列表",
      path:"/goods",
      component:Goods
    },
    {
      name:"购买人列表",
      path:"/customer",
      component:Customer
    },
    {
      name:"购买",
      path:"/buy",
      component:Buy
    },
    {
      name:"购买完成",
      path:"/complete",
      component:Complete
    },
    {
      name:"店铺首页",
      path:"/home",
      component:Home
    },
    //一周年活动 叠加为2周年
    {
      name:"首页",
      path:"/anniversary_home",
      component:()=> import ('../components/anniversary/home.vue')
    },
    {
      name:"存在天数",
      path:"/page1",
      component:()=> import ("../components/anniversary/view/page1.vue")
    },
    {
      name:"老用户页面",
      path:"/page2",
      component:()=> import ("../components/anniversary/view/page2.vue")
    },
    {
      name:"老用户回归礼包",
      path:"/page3",
      component:()=> import ("../components/anniversary/view/page3.vue")
    },
    {
      name:"游戏历史",
      path:"/page4",
      component:()=> import ("../components/anniversary/view/page4.vue")
    },
    {
      name:"战绩记录",
      path:"/page6",
      component:()=> import ("../components/anniversary/view/page6.vue")
    },
    {
      name:"用户状态",
      path:"/page7",
      component:()=> import ("../components/anniversary/view/page7.vue")
    },
    {
      name:"剧本记录状态",
      path:"/page8",
      component:()=> import ("../components/anniversary/view/page8.vue")
    },
    {
      name:"礼物接收",
      path:"/page9",
      component:()=> import ("../components/anniversary/view/page9.vue")
    },
    {
      name:"cp 展示",
      path:"/page10",
      component:()=> import ("../components/anniversary/view/page10.vue")
    },
    {
      name:'我是狼人',
      path:'/lrspage',
      component:()=> import ("../components/anniversary/view/pagelrs.vue")
    },
    {
      name:"cp信息",
      path:"/page11",
      component:()=> import ("../components/anniversary/view/page11.vue")
    },
    {
      name:"无cp",
      path:"/page12",
      component:()=> import ("../components/anniversary/view/page12.vue")
    },
    //历史大事件
    {
      name:"事件1",
      path:"/history1",
      component:()=> import ("../components/anniversary/view/history1.vue")
    },
    {
      name:"事件6",
      path:"/history6",
      component:()=> import ("../components/anniversary/view/history6.vue")
    },
    {
      name:"事件2",
      path:"/history2",
      component:()=> import ("../components/anniversary/view/history2.vue")
    },
    {
      name:"事件3",
      path:"/history3",
      component:()=> import ("../components/anniversary/view/history3.vue")
    },
    {
      name:"事件4",
      path:"/history4",
      component:()=> import ("../components/anniversary/view/history4.vue")
    },
    {
      name:"事件5",
      path:"/history5",
      component:()=> import ("../components/anniversary/view/history5.vue")
    },
   
    //分享页面
    {
      name:"分享",
      path:"/page13",
      component:()=> import ("../components/anniversary/view/page13.vue")
    },
    // 浪漫海岛游支付页面
    {
      name:"支付首页",
      path:"/pay_home",
      component:()=> import ("../components/H5pay/view/payhome.vue")
    },
    {
      name:"支付方式",
      path:"/payment",
      component:()=> import ("../components/H5pay/view/payment.vue")
    },
    {
      name:"订单详情",
      path:"/ordetail",
      component:()=> import ("../components/H5pay/view/ordetail.vue")
    },
    {
      name:"行程",
      path:"/tinerary",
      component:()=> import ("../components/H5pay/components/tinerary.vue")
    },
    //h5 活动 已弃用
    {
      path:"/gift_home",
      name :'giftHome',
      component:()=> import ("../components/h5gifts/view/giftHome.vue")
    },
    {
      path: '/active_info',
      name: 'activeInfo',
      component: ()=>import("../components/h5gifts/view/activeInfo.vue"),
    },
    {
      path: '/receive_list',
      name: 'reContribution',
      component: ()=>import("../components/h5gifts/view/reContribution.vue"),
    },
    {
      path: '/send_list',
      name: 'seContribution',
      component: ()=>import("../components/h5gifts/view/seContribution.vue"),
    },
    {
      path: '/emptypages',
      name: 'Emptypages',
      component: ()=>import("../components/h5gifts/view/Emptypages.vue"),
    },
    //banner 临时剧本活动
    {
      path: '/actindex',
      name: 'Actindex',
      component: ()=>import("../components/actindex.vue"),
    },
    //账号注销 start
    {
      path: '/logout',
      name: 'Logout',
      component: ()=>import("../components/logout.vue"),
    },
    {
      path: '/logout_rules',
      name: 'LogoutRules',
      component: ()=>import("../components/logoutrules.vue"),
    },
    {
      path: '/logout_result',
      name: 'result',
      component: ()=>import("../components/toast.vue"),
    }
    //账号注销end
    
     
  ] 
  
})
router.beforeEach((to, from, next) => {
  // 微信分享时，微信会在地址栏添加额外参数
  if (restoreUrl.isWeChatUrl()) {
    window.location.href = restoreUrl.getProjectUrl();
  }else{
    next();
  }
})

export default router;






// WEBPACK FOOTER //
// ./src/router/index.js